<template>
  <div>
    <nr-generic
      title="Notas de Reembolso dos Clientes"
      namespace="refund_notes"
      searchObject='customer'
      :searchFields="['name']"
      :showFilter="true"
      :showPagination="true"
      >
      <template v-slot:header>
        <th v-for="item in headers">{{ item.label }}</th>
      </template>
      <template v-slot:item="{ item }">
        <td>
          <router-link :to="'/financials/repayment/' + item.pk">{{ item.code }}</router-link> <br>
          <!-- <small v-if="$store.getters['auth/isAdmin']" class="text-muted" title="Criado por">{{ item.created_by }}</small> -->
        </td>
        <td>{{ item.customer.name }}</td>
        <td>{{ item.expiration_date | formatDate }}</td>
        <td>R$ {{ item.total }}</td>
        <td><i class="fa" :class="item.paid ? 'fa-check ok': 'fa-close no'"></i></td>
      </template>
    </nr-generic>
  </div>
</template>
<script>
import NRGeneric from './NRGeneric';

export default {
  components: {
    'nr-generic': NRGeneric,
  },
  data() {
    return {
      headers: [
        { label: 'Nota' },
        { label: 'Cliente' },
        { label: 'Vencimento' },
        { label: 'Valor' },
        { label: 'Status (pago)' },
      ]
    }
  }
}
</script>
